// extracted by mini-css-extract-plugin
export var overlay = "styles-module--overlay--psC4r";
export var container = "styles-module--container--SEPsi";
export var fixedHeight = "styles-module--fixedHeight--r+kBh";
export var noHeader = "styles-module--noHeader--fpcyu";
export var sm = "styles-module--sm--Yq42C";
export var lg = "styles-module--lg--CM6Q5";